import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

// Async thunk for analyzing sentiment
export const fetchSentiment = createAsyncThunk(
  'sentiment/analyzeSentiment',
  async ({ text, filters }, { rejectWithValue }) => {
    try {
      const response = await apiCall('/analyze-sentiment', 'POST', { text, filters });
      // Check if the response contains an error
      if (response.error) {
        return rejectWithValue(response.message);
      }
      return response;
    } catch (error) {
      return rejectWithValue('An unexpected error occurred while analyzing sentiment');
    }
  }
);

const SentimentSlice = createSlice({
  name: 'sentimentAnalyzer',
  initialState: {
    results: null, // Stores sentiment analysis results
    loading: false, // API request state
    error: null, // Error message for failed requests
  },
  reducers: {
    clearResults: (state) => {
      state.results = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSentiment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.results = null;
      })
      .addCase(fetchSentiment.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload || null;
      })
      .addCase(fetchSentiment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to analyze sentiment';
      });
  },
});

// Reusable selectors for state access
export const selectResults = (state) => state.sentimentAnalyzer.results;
export const selectLoading = (state) => state.sentimentAnalyzer.loading;
export const selectError = (state) => state.sentimentAnalyzer.error;

export const { clearResults } = SentimentSlice.actions;
export default SentimentSlice.reducer;
